import { EmptySection } from './empty-section';

export class PlantlifeNonSmokableEmptySection extends EmptySection {
  public backgroundColor: string;
  public borderColor: string;
}
